import * as api from '../api'

//Action Creators
export const getReceipts = () => async (dispatch) => {
  try {
    const { data } = await api.fetchReceipts()
    dispatch({ type: 'FETCH_RECEIPTS', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error.response.data.message,
    })
  }
}
